import React from 'react';

interface Props {
  message: string;
}

export const ErrorMessage: React.FC<Props> = ({ message }) => <div className="text-red" dangerouslySetInnerHTML={{ __html: message }} />;
